/**
 * Convenience utility for getting all map entry keys where the entry value passes a test function
 *
 * @method getMatchingMapEntryKeys
 * @param {Map} map
 * @param {Function} matchFunction - function to call on map entry value to determine if it matches
 * @returns {Array} array of matching map entry keys
 */
const getMatchingMapEntryKeys = (map, matchFunction = () => false) => {
  const newSet = new Set();

  map.forEach((value, document) => {
    if (matchFunction(value)) {
      newSet.add(document);
    }
  });

  return newSet;
};

export default getMatchingMapEntryKeys;
